import { HttpEvent, HttpEventType } from '@angular/common/http';
import type { BdUiProgressStep } from '@bindoc-projects/ui-lib/feedback/ui';

export type KostDataImportUploadState = 'init' | 'uploading' | 'failed';

/** What one event of a `reportProgress` upload means for the transfer step. */
export type KostDataImportUploadEvent =
  | { kind: 'progress'; percent: number | null }
  | { kind: 'done'; body: unknown }
  | null;

export function uploadEvent(
  event: HttpEvent<unknown>,
): KostDataImportUploadEvent {
  switch (event.type) {
    case HttpEventType.UploadProgress:
      return {
        kind: 'progress',
        percent: event.total ? (event.loaded / event.total) * 100 : null,
      };
    case HttpEventType.Response:
      return { kind: 'done', body: event.body };
    default:
      return null;
  }
}

/**
 * Steps of `bd-ui-step-progress` while the dataset is transferred. With a job
 * chain the processing follows as a waiting step, so the list matches the
 * chain status that takes over once the upload is done.
 */
export function uploadSteps(
  state: Exclude<KostDataImportUploadState, 'init'>,
  percent: number | null,
  withProcessing: boolean,
): BdUiProgressStep[] {
  const transfer: BdUiProgressStep =
    state === 'failed'
      ? { label: 'Datensatz übertragen', state: 'failed' }
      : { label: 'Datensatz übertragen', state: 'running', percent };

  return withProcessing
    ? [transfer, { label: 'Verarbeitung', state: 'waiting' }]
    : [transfer];
}
